import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  SparklesIcon,
  HomeIcon,
  CogIcon,
  ChartBarIcon 
} from '@heroicons/react/24/outline';

export default function Navbar() {
  const location = useLocation();

  const navigation = [
    { name: 'Configurations', href: '/', icon: CogIcon },
    { name: 'Dashboard', href: '/dashboard', icon: ChartBarIcon }
  ];

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <SparklesIcon className="h-8 w-8 text-blue-600 mr-2" />
            <span className="text-xl font-bold text-gray-900">YourFabric</span>
            <span className="text-sm text-gray-500 ml-2">AI Classification</span>
          </Link>

          {/* Navigation Links */}
          <div className="flex space-x-8">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }`}
                >
                  <item.icon className="h-4 w-4 mr-2" />
                  {item.name}
                </Link>
              );
            })}
          </div>

          {/* User Menu */}
          <div className="flex items-center">
            <span className="text-sm text-gray-600">AI-Powered Custom Classification</span>
          </div>
        </div>
      </div>
    </nav>
  );
}